import React from 'react';
import { personalInfo, socialLinks } from '../data/mockData';
import { Instagram, Twitter, Linkedin } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

const LeftSidebar = () => {
  const { isDark } = useTheme();
  
  const iconMap = {
    Instagram: Instagram,
    Twitter: Twitter,
    LinkedIn: Linkedin
  };

  return (
    <aside className="left-sidebar">
      <div className="sidebar-content">
        {/* Profile Card */}
        <div className="profile-card">
          {/* Decorative element */}
          <div className="decorative-shape top-shape">
            <svg viewBox="0 0 194 100" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 34.544L3.22 33.201C4.186 35.732 5.256 38.221 6.429 40.663L3.329 42.293C2.113 39.757 1.002 37.172 0 34.544Z" fill="#f46c38"/>
            </svg>
          </div>

          {/* Profile Image */}
          <div className="profile-image-container">
            <img
              src={personalInfo.profileImage}
              alt={personalInfo.name}
              className="profile-image"
            />
          </div>

          {/* Bio Section */}
          <div className="bio-section">
            <h1 className="profile-name">{personalInfo.name}</h1>
            <p className="profile-tagline">{personalInfo.tagline}</p>
            
            {/* Social Icons */}
            <div className="social-icons">
              {socialLinks.map((link) => {
                const IconComponent = iconMap[link.name];
                return (
                  <a
                    key={link.id}
                    href={link.url}
                    className="social-icon"
                    aria-label={link.name}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <IconComponent size={18} />
                  </a>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .left-sidebar {
          width: 380px;
          min-width: 380px;
          height: 100vh;
          position: fixed;
          top: 0;
          left: 0;
          padding: 24px;
          box-sizing: border-box;
          z-index: 10;
        }

        .sidebar-content {
          height: 100%;
        }

        .profile-card {
          background: ${isDark ? '#fff' : '#fff'};
          border-radius: 16px;
          height: 100%;
          display: flex;
          flex-direction: column;
          position: relative;
          overflow: hidden;
          transition: background-color 0.3s ease, box-shadow 0.3s ease;
          box-shadow: ${isDark ? 'none' : '0 4px 24px rgba(0, 0, 0, 0.08)'};
        }

        .decorative-shape {
          position: absolute;
          z-index: 1;
          display: none;
        }

        .top-shape {
          top: 20px;
          left: 20px;
          width: 100px;
          height: 50px;
        }

        .top-shape svg {
          width: 100%;
          height: 100%;
        }

        .profile-image-container {
          flex: 1;
          min-height: 0;
          position: relative;
          overflow: hidden;
          border-radius: 16px;
          margin: 16px;
          margin-bottom: 0;
        }

        .profile-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 16px;
        }

        .bio-section {
          padding: 24px;
          text-align: center;
        }

        .profile-name {
          font-family: 'Poppins', sans-serif;
          font-size: 28px;
          font-weight: 700;
          color: #151312;
          margin: 0 0 12px 0;
          letter-spacing: -0.04em;
          line-height: 1.1;
        }

        .profile-tagline {
          font-family: 'Poppins', sans-serif;
          font-size: 14px;
          font-weight: 500;
          color: #6a6b6e;
          margin: 0 0 20px 0;
          line-height: 1.4;
          white-space: pre-line;
        }

        .social-icons {
          display: flex;
          justify-content: center;
          gap: 12px;
        }

        .social-icon {
          width: 36px;
          height: 36px;
          border-radius: 6px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #f46c38;
          background: transparent;
          transition: all 0.2s ease;
        }

        .social-icon:hover {
          background: rgba(244, 108, 56, 0.1);
          transform: translateY(-2px);
        }

        @media (max-width: 1024px) {
          .left-sidebar {
            width: 100%;
            min-width: auto;
            height: auto;
            position: relative;
            padding: 16px;
            max-width: 100vw;
            overflow-x: hidden;
          }

          .profile-card {
            height: auto;
          }

          .profile-image-container {
            height: 350px;
            flex: none;
          }

          .profile-name {
            font-size: 24px;
          }

          .profile-tagline {
            font-size: 13px;
          }

          .bio-section {
            padding: 20px 16px;
          }

          .decorative-shape {
            display: none;
          }
        }

        @media (max-width: 480px) {
          .left-sidebar {
            padding: 12px;
          }

          .profile-image-container {
            height: 280px;
            margin: 12px;
          }

          .profile-name {
            font-size: 22px;
          }
        }
      `}</style>
    </aside>
  );
};

export default LeftSidebar;
